import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../store/app.states';
import {MatDialog} from '@angular/material/dialog';
import * as _moment from 'moment';
import {DoctorService} from '../../../services/doctor.service';
import {MatSnackBar} from '@angular/material/snack-bar';

import {MatSort} from '@angular/material/sort';
import { Announcement } from 'src/app/model/announcement/Announcement';

@Component({
  selector: 'app-announcement-doctor',
  templateUrl: './announcement-doctor.component.html',
  styleUrls: ['./announcement-doctor.component.css']
})
export class AnnouncementDoctorComponent implements OnInit {
  
      getAuthState: Observable<any>;
      isAuthenticated: boolean;
      user = null;
      errorMessage = null;
      title = 'Avvisi'; // titolo generale
      destination = 'landing';
    
      // servono per la comparsa/scomparsa di componenti nella pagina web
      isDataAvailable = true;
      getDoctorState: Observable<any>;
      @ViewChild(MatSort) sort: MatSort;

      subscription1: Subscription;
      subscription2: Subscription;
      textSend = '';

      announcements : Announcement[];

      constructor(private router: Router,
        private store: Store<AppState>,
        private doctorService: DoctorService,
        public dialog: MatDialog,
        public snackBar: MatSnackBar) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
    }
    
      ngOnInit(): void {
        this.getAuthState.subscribe((state) => {
          this.isAuthenticated = state.isAuthenticated;
          this.user = JSON.parse(localStorage.getItem('user'));
          this.errorMessage = state.errorMessage;
          this.getAnnouncements();
        });
      }

      openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
          duration: 2000,
        });
      }

      sendAnnouncement() {
         let textToSend = this.textSend;
        this.textSend = '';
        this.subscription2 = this.doctorService.sendAnnouncement(textToSend).subscribe(received => {
          const newMessageParsed = JSON.parse(received.body);
          if(textToSend===newMessageParsed.text) {
            //Ok
            this.openSnackBar("Avviso pubblicato con successo!","Chiudi!");
            setTimeout(() => location.replace('/announcement-section'), 1500);


          }
        }, error => {
          if (error.status === 500) {
            // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
            localStorage.setItem('expirationTime', '0');
            console.log('sessione scaduta');
            location.reload();
          }
          // this.openErrorDialog('Il messaggio non è stato mandato per un errore. Se il problema persiste ci contatti via e-mail');
        });
      }

      getAnnouncements() {
        this.subscription1 = this.doctorService.getAnnouncements().subscribe(received => {
          this.announcements=received;
          console.log(this.announcements);
          this.announcements.forEach(function(announcement){
            announcement.giorno = (new Date(announcement.date).getDate());
            announcement.mese = (new Date(announcement.date).getMonth()+1);
            announcement.anno = (new Date(announcement.date).getFullYear());
          } );
        }, error => {
          if (error.status === 500) {
            // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
            localStorage.setItem('expirationTime', '0');
            console.log('sessione scaduta');
            location.reload();
          }
          // this.openErrorDialog('Il messaggio non è stato mandato per un errore. Se il problema persiste ci contatti via e-mail');
        });
      }
      ngOnDestroy() {
        this.subscription1.unsubscribe();
      }
    }
    